<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
import Button from 'primevue/button';
import AppModal from '@/components/ui/AppModal.vue';

interface Props {
    visible: boolean
    title: string
    message: string
}

defineProps<Props>();

const emit = defineEmits<{
    'update:visible': [value: boolean]
}>();

function close(): void {
    emit('update:visible', false);
}
</script>

<template>
    <AppModal
        :visible="visible"
        :title="title"
        width="520px"
        @update:visible="emit('update:visible', $event)"
    >
        <p class="queued-export-modal__message">
            {{ message }}
        </p>

        <template #footer>
            <Button
                type="button"
                label="Close"
                class="queued-export-modal__close-btn"
                @click="close"
            />
        </template>
    </AppModal>
</template>

<style lang="scss" scoped>
.queued-export-modal__message {
    margin: 0;
    font-family: $font-family-archivo;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: rgba($black-color, 0.75);
}

.queued-export-modal__close-btn {
    width: 91px !important;
    height: 46px !important;
    border-radius: 10px !important;
    border: 1px solid $main-orange !important;
    background: $main-orange !important;
    font-family: $font-family-archivo !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    line-height: 17px !important;
    color: $white-color !important;
    box-shadow: none !important;
    padding: 0 !important;
    justify-content: center;

    &:hover {
        background: $main-orange-hover !important;
        border-color: $main-orange-hover !important;
    }
}
</style>
